import HBIcon from "@/components/HBIcon";
import HBPopover from "@/components/HBPopover";
import Link from "next/link";
import styles from "./index.module.less";

export default function LeftInfo({ config }) {
  if (!config) {
    return null;
  }

  const { title, list, extraTitle, extraDesc, extraTip } = config;

  return (
    <div className={styles.leftInfo}>
      <div className={styles.title}>
        <span
          className={styles.vip}
          dangerouslySetInnerHTML={{ __html: title }}
        ></span>
        核心权益
      </div>
      <div className={styles.middle}>
        <ul>
          {list.map((item) => (
            <li key={item.title}>
              <HBIcon type="ic_check_circle" className={styles.checkIcon} />
              <span>
                <span dangerouslySetInnerHTML={{ __html: item.title }}></span>
                {item.tip && (
                  <HBPopover
                    content={
                      <>
                        <div
                          className={styles.tipText}
                          dangerouslySetInnerHTML={{ __html: item.tip }}
                        ></div>
                      </>
                    }
                    overlayInnerStyle={{ width: 239 }}
                    placement="bottom"
                  >
                    <HBIcon className={styles.infoIcon} type="ic_help" />
                  </HBPopover>
                )}
              </span>
            </li>
          ))}
        </ul>

        {extraTitle && (
          <div className={styles.extra}>
            <div className={styles.name}>
              {extraTitle}
              {extraTip && (
                <HBPopover
                  content={
                    <>
                      <div
                        className={styles.tipText}
                        dangerouslySetInnerHTML={{ __html: extraTip }}
                      ></div>
                    </>
                  }
                  overlayInnerStyle={{ width: 239 }}
                  placement="top"
                >
                  <HBIcon className={styles.infoIcon} type="ic_info" />
                </HBPopover>
              )}
            </div>
            <div
              className={styles.desc}
              dangerouslySetInnerHTML={{
                __html: extraDesc,
              }}
            ></div>
          </div>
        )}
        <a className={styles.moreBtn} href={"/vip/info?anchor=discoveryRange"}>
          查看会员版本对比
        </a>
      </div>

      <div className={styles.links}>
        <Link href="https://support.qq.com/products/30852/faqs-more/#classifyId=87404">
          <a target="_blank">常见问题</a>
        </Link>
        ｜
        <Link href="/vip/exchange">
          <a target="_blank">会员兑换</a>
        </Link>
      </div>
    </div>
  );
}
